import { DASHBOARD, NOTIFICATIONS } from '@constants/internal-route.constant';
import { IAppRoutes } from '@interface/common.interface';
import { lazy } from 'react';
import { InventoryRoutes } from './inventory.routes';
import { SetupRoutes } from './setup.routes';
import { ProcurementRoutes } from './procurement.routes';
import { ApprovalsRoutes } from './approvals.routes';
import { ReportRoutes } from './report.routes';
import { ROUTE_CODES } from '@constants/route-codes.constant';
import LandingRedirect from '../LandingRedirect';

export const AppRouteList: IAppRoutes[] = [
  {
    link: DASHBOARD,
    element: lazy(() => import('pages/dashboard/DashboardWrapper')),
    routeCode: ROUTE_CODES.DASHBOARD,
  },
  {
    // In-app notifications — reached from the topbar bell's "View all", not the sidebar.
    // Deliberately no routeCode (= ungated): the feed is already scoped in SQL to the
    // caller's own user_id, so every user may open their own notifications.
    link: NOTIFICATIONS,
    element: lazy(() => import('@modules/notification/NotificationList')),
  },
  { ...SetupRoutes },
  { ...InventoryRoutes },
  { ...ProcurementRoutes },
  { ...ApprovalsRoutes },
  { ...ReportRoutes },
  {
    // The portal hand-off lands here: the role's landing page in this app, else the dashboard.
    link: 'auth/*',
    element: LandingRedirect,
  },
];
